import React from 'react';
import type { UseRequiresAuthOptions } from './useRequiresAuth';
import { useRequiresAuth } from './useRequiresAuth';

export type AuthenticationGuardProps = UseRequiresAuthOptions & {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

const AuthenticationGuard: React.FC<AuthenticationGuardProps> = ({
  children,
  fallback = null,
  ...options
}) => {
  const { shouldRender } = useRequiresAuth(options);

  if (!shouldRender) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default AuthenticationGuard;
